import React, {useEffect, useState, useContext, useRef} from "react";
import {useHistory, useLocation} from "react-router-dom";
import styles from "./filters/Filters.module.scss";
import FilterWrapper from "./filters/FilterWrapper";
import FilterItem from "./filters/FilterItem";
import {Scrollbars} from "react-custom-scrollbars";
import VariantsFilterPicker from "./filters/VariantsFilterPicker";
import CaseAttributesFilterPicker from "./filters/CaseAttributesFilterPicker";
import DateAndTimeFilterPicker from "./filters/DateAndTimeFilterPicker";
import appContext from "../../../../context/appContext";
import Button from "../../../Componnets/Button/Button";
import CaseCoverage from "./filters/CaseCoverage";
import apiCaseCoverage from "../../../../services/api/apiCaseCoverage";
import moment from "moment";
import FlowSelection from "./filters/FlowSelection";
import Metrics from "./filters/Metrics";
import SwitchKey from "../../../Componnets/SwitchKey/SwitchKey";
import JalaliMoment from "jalali-moment"
import LayerSelection from "./filters/LayerSelection";
import ActivitySelection from "./filters/ActivitySelection";

const Filters = ({showModal = false, showActiveFiltersPopup = false, handleTriggerShowModal, mode}) => {
  const context = useContext(appContext);
  const [hasError, setHasError] = useState(false);
  const [disableSubmitButton, setDisableSubmitButton] = useState(true);
  const [showMore, setShowMore] = useState(false);
  const [caseCoverageData, setCaseCoverageData] = useState({});
  const [disabledFilters, setDisabledFilters] = useState([]);
  const [caseCoverageStatus, setCaseCoverageStatus] = useState(null)
  const [isDoneClicked, setIsDoneClicked] = useState(false)
  const [canCallCaseCoverageDirectly, setCanCallCaseCoverageDirectly] = useState(true)
  const [canCallCaseCoverageApi, setCanCallCaseCoverageApi] = useState(true)
  const [filtersList, setFiltersList] = useState({
    variants: {
      id: 1,
      type: 'variants',
      title: 'Variants',
      isActive: false,
      isSelected: false,
      isDisabled: false,
      data: []
    },
    flowSelection: {
      id: 2,
      type: 'flowSelection',
      title: 'Flow Selection',
      isActive: false,
      isSelected: false,
      data: []
    },
    caseAttributes: {
      id: 3,
      type: 'caseAttributes',
      title: 'Case Attributes',
      isActive: false,
      isSelected: false,
      data: []
    },
    dateAndTime: {
      id: 4,
      type: 'dateAndTime',
      title: 'Date & Time',
      isActive: false,
      isSelected: false,
      data: [],
      originalData: [],
      isDisabled: false
    },
    metrics: {
      id: 6,
      type: 'metrics',
      title: 'Metrics',
      isActive: false,
      isSelected: false,
      isDisabled: false
    },
    activitySelection: {
      id: 7,
      type: 'activitySelection',
      title: 'Activity Selection',
      isActive: false,
      isSelected: false,
      isDisabled: false
    },
    activitySequence: {
      id: 5,
      type: 'activitySequence',
      title: 'Activity Sequence',
      isActive: false,
      isSelected: false,
      isDisabled: true
    },
  });

  const history = useHistory();
  let savedVariants = context.handleAutoSave().processMapVariants;
  let savedFilters = context.handleAutoSave().processMapFilters;
  let savedActiveVariants = context.state && context.state.activeVariantsProcessMap;
  let savedFlowSelection = context.handleAutoSave().processMapFlow;
  let savedMetrics = context.handleAutoSave().processMapMetrics;
  let savedActivitySelection = context.handleAutoSave().processMapAdvancedActivityFilters;

  if (history.location.pathname === '/process-compare') {
    if (context?.handleLayerList()?.length && context?.handleLayerList()?.find(item => item.selected)?.type !== "mainLayer") {
      const selectedLayerFilters = context.handleLayerList()?.find(item => item.selected)?.temporaryAppliedFilters
      savedVariants = selectedLayerFilters?.variants
      savedActiveVariants = selectedLayerFilters?.active_variants
      savedFilters = selectedLayerFilters?.filters
      savedFlowSelection = selectedLayerFilters?.flow
      savedMetrics = selectedLayerFilters?.metrics
      savedActivitySelection = selectedLayerFilters?.advanced_activity_filters
    } else {
      const selectedLayerFilters = context.handleLayerList()?.find(item => item.type === "mainLayer")?.temporaryAppliedFilters
      savedVariants = selectedLayerFilters?.variants
      savedActiveVariants = selectedLayerFilters?.active_variants
      savedFilters = selectedLayerFilters?.filters
      savedFlowSelection = selectedLayerFilters?.flow
      savedMetrics = selectedLayerFilters?.metrics
      savedActivitySelection = selectedLayerFilters?.advanced_activity_filters
    }
  } else if (history.location.pathname === '/generate-bpmn-model') {
    savedVariants = context.handleSaveGenerateBpmnFilters().variants;
    savedFilters = context.handleSaveGenerateBpmnFilters().filters;
    savedActiveVariants = context.handleSaveGenerateBpmnFilters().activeVariants;
    savedFlowSelection = context.handleSaveGenerateBpmnFilters().flow;
    savedMetrics = context.handleSaveGenerateBpmnFilters().metrics;
    savedActivitySelection = context.handleSaveGenerateBpmnFilters().activitySelection
  } else if (history.location.pathname === '/data-analysis' || history.location.pathname.includes("share/data_analysis")) {
    savedVariants = context.handleAutoSave().dataAnalysisVariants;
    savedFilters = context.handleAutoSave().dataAnalysisFilters;
    savedActiveVariants = context.handleAutoSave().dataAnalysisActiveVariants;
    savedFlowSelection = context.handleAutoSave().dataAnalysisFlow;
    savedMetrics = context.handleAutoSave().dataAnalysisMetrics;
    savedActivitySelection = context.handleAutoSave().dataAnalysisAdvancedActivityFilters;
  } else if (history.location.pathname === '/process-explorer') {
    savedVariants = context.state.processExplorerVariants;
    savedFilters = context.state.processExplorerFilters;
    savedActiveVariants = context.state.processExplorerActiveVariants;
    savedFlowSelection = context.state.processExplorerFlow;
    savedMetrics = context.state.processExplorerMetrics;
    savedActivitySelection = context.state.processExplorerAdvancedActivityFilters;
  } else if (history.location.pathname === '/conformance-checking') {
    savedVariants = context.state.conformanceCheckingVariants;
    savedFilters = context.state.conformanceCheckingFilters;
    savedActiveVariants = context.state.conformanceCheckingActiveVariants;
    savedFlowSelection = context.state.conformanceCheckingFlow;
    savedMetrics = context.state.conformanceCheckingMetrics;
    savedActivitySelection = context.state.conformanceCheckingAdvancedActivityFilters;
  }

  if (savedVariants?.length || savedFilters?.length || savedFlowSelection?.length || savedActivitySelection?.length) {
    context.handleHasSavedFilters(true)
  } else {
    context.handleHasSavedFilters(false)
  }

  let variantsList = context.handleListOfVariants();
  useEffect(() => {
    let caseAttributesData = [];
    let variantsData = [];
    let dateAndTimeOriginalData = [];
    if ((history.location.pathname === "/variant-explorer" || history.location.pathname === "/process-compare") && !savedActiveVariants?.length) {
      savedVariants = [1]
      savedActiveVariants = [1]
    }
    if (savedVariants?.length) {
      // Variant ids and their active states are updated independently. After
      // submitting, the modal can be mounted again before `activeVariants` or
      // the variants catalogue is ready. Rebuild by saved id and fall back to
      // the current item/default active state instead of clearing the filter.
      variantsData = savedVariants.map((savedId, index) => {
        const variant = variantsList?.find(item => String(item.id) === String(savedId))
          || filtersList.variants.data.find(item => String(item.id) === String(savedId))
          || {id: savedId};

        return {
          ...variant,
          is_active: savedActiveVariants?.[index] ?? variant.is_active ?? 1
        };
      });
    }

    if (savedFilters && savedFilters.length > 0) {
      dateAndTimeOriginalData = savedFilters.filter(item => item.column.find(i => i === "STARTTIME" || i === "ENDTIME" || i === "TIMESTAMP"));
      caseAttributesData = savedFilters.filter(item => !item.column.find(i => i === "STARTTIME" || i === "ENDTIME" || i === "TIMESTAMP"));
    }

    const filtersListData = {...filtersList,
      variants: {...filtersList.variants, data: variantsData, isActive: true},
      dateAndTime: {
        ...filtersList.dateAndTime,
        data: dateAndTimeOriginalData,
        originalData: dateAndTimeOriginalData,
        isActive: true
      },
      caseAttributes: {...filtersList.caseAttributes, data: caseAttributesData, isActive: true},
      flowSelection: {...filtersList.flowSelection, data: savedFlowSelection, isActive: true},
      metrics: {...filtersList.metrics, data: savedMetrics, isActive: true},
      activitySelection: {...filtersList.activitySelection, data: savedActivitySelection, isActive: true}
    }
    setFiltersList(filtersListData);
    if (!showModal) {
      if (history.location.pathname === "/variant-explorer" || history.location.pathname === "/process-compare") {
        if (history.location.pathname !== "/process-compare") {
          if(JSON.stringify(filtersListData) !== JSON.stringify(filtersList)) {
            getCaseCoverageData(filtersListData)
          }
        }
      } else if (history.location.pathname === "/process-explorer") {
        if (canCallCaseCoverageDirectly || Object.values(filtersListData)?.map(item => item.data)?.find(item => item?.length)) {
          getCaseCoverageData(filtersListData)
          setCanCallCaseCoverageDirectly(false)
        }
      } else {
        getCaseCoverageData(filtersListData)
      }
    }
  }, [savedFilters, savedVariants, savedFilters, savedMetrics, savedActivitySelection, savedFlowSelection, variantsList, context.handleLayerList()]);

  useEffect(() => {
    if (location.pathname === "/process-compare" && !context.handleIsFiltersModalOpen()) {
      const data = context.handleLayerList().find(item => item.type === "mainLayer")?.appliedFilters
      if (data) {
        callApiCaseCoverage(data)
      }
    }
  }, [context.handleLayerList()])

  useEffect(() => {
    if(location.pathname.includes("/share/data_analysis/")){
      callApiCaseCoverage({},true)
    }
  }, [context.handleUid().id]);

  useEffect(() => {
    if (location.pathname === "/process-compare" && showModal) {
      const data = context.handleLayerList().find(item => item.selected)?.appliedFilters
      if (data) {
        callApiCaseCoverage(data)
      }
    }
  }, [showModal, context.handleLayerList().find(item => item.selected)?.appliedFilters])

  useEffect(() => {
    const overrideData = context.handleOverrideDataAnalysisFilters()
    if (history.location.pathname === "/data-analysis" && overrideData && Object.keys(overrideData).length !== 0) {
      const oldFlowData = overrideData?.currentFilters?.flow || []
      const flow = overrideData.newFlowSelection ? [...oldFlowData, {
        is_active: true,
        seq: overrideData.newFlowSelection?.fromNode ? [
          {
            activity_name: overrideData?.newFlowSelection?.fromNode,
            type: "directly_followed",
          },
          overrideData?.newFlowSelection?.toNode ? {
            activity_name: overrideData?.newFlowSelection?.toNode,
            type: "ENDSEQUENCE",
          } : overrideData?.newFlowSelection?.toListOfNodes?.map(item => ({
            activity_name: item,
            type: "directly_followed",
          })),
        ]?.reduce((acc, val) => acc.concat(val), []) : [
          {
            activity_name: overrideData?.newFlowSelection?.node,
            type: "ENDSEQUENCE",
          },
        ]
      }] : [...oldFlowData]

      savedVariants = overrideData.currentFilters?.variants;
      savedFilters = overrideData.currentFilters?.filters;
      savedActiveVariants = overrideData.currentFilters?.active_variants;
      savedMetrics = overrideData.currentFilters?.metrics;
      savedFlowSelection = overrideData.currentFilters?.flow;
      savedActivitySelection = overrideData.currentFilters?.advanced_activity_filters;

      const list = {
        ...filtersList,
        flowSelection: {...filtersList.flowSelection, data: flow},
      };

      setTimeout(() => {
        handleSubmit(list)
        context.handleOverrideDataAnalysisFilters({})
      }, 2000)
    }
  }, [context.handleOverrideDataAnalysisFilters()])

  useEffect(() => {
    if (showModal || showActiveFiltersPopup) {
      setFiltersList({
        ...filtersList,
        flowSelection: {...filtersList.flowSelection, isSelected: false},
        dateAndTime: {...filtersList.dateAndTime, isSelected: false},
        caseAttributes: {...filtersList.caseAttributes, isSelected: false},
        metrics: {...filtersList.metrics, isSelected: false}
      });
      getCaseCoverageData();
    }
  }, [showModal, showActiveFiltersPopup]);

  const handleAddFiltersToProcessCompareLayersTemporary = (filterType, filterData) => {
    if (history.location.pathname === "/process-compare") {
      const selectedLayerTemporaryFilters = context.handleLayerList()?.find(item => item.selected)?.temporaryAppliedFilters

      let temporarySavedVariants = selectedLayerTemporaryFilters?.variants,
          temporarySavedActiveVariants = selectedLayerTemporaryFilters?.active_variants,
          temporarySavedFilters = selectedLayerTemporaryFilters?.filters,
          temporarySavedFlowSelection = selectedLayerTemporaryFilters?.flow,
          temporarySavedMetrics = selectedLayerTemporaryFilters?.metrics,
          temporarySavedActivitySelection = selectedLayerTemporaryFilters?.activitySelection

      switch (filterType) {
        case "variants":
          temporarySavedVariants = filterData.variants?.data?.map(item => item.id)
          temporarySavedActiveVariants = filterData.variants?.data?.map(item => item.is_active || 1)
          break
        case "caseAttributes":
        case "dateAndTime":
          temporarySavedFilters = [...filterData.dateAndTime?.data, ...filterData.caseAttributes?.data]
          break
        case "flowSelection":
          temporarySavedFlowSelection = filterData.flowSelection?.data
          break
        case "metrics":
          temporarySavedMetrics = filterData.metrics?.data
          break
        case "activitySelection":
          temporarySavedActivitySelection = filterData.activitySelection?.data
          break
        default:
          break
      }

      const temporaryAppliedFilters = {
        variants: temporarySavedVariants,
        active_variants: temporarySavedActiveVariants,
        filters: temporarySavedFilters,
        flow: temporarySavedFlowSelection,
        metrics: temporarySavedMetrics,
        advanced_activity_filters: temporarySavedActivitySelection,
      }

      const copyOfLayersList = [...context.handleLayerList()]
      const selectedLayerIndex = copyOfLayersList?.findIndex(item => item.selected)
      selectedLayerIndex > -1 && copyOfLayersList.splice(selectedLayerIndex, 1, {
        ...copyOfLayersList[selectedLayerIndex],
        temporaryAppliedFilters
      })
      context.handleLayerList(copyOfLayersList)
    }
  }

  const handleSetVariantsFiltersList = (data) => {
    const ids = new Set(data.map(({id}) => id));
    const oldSelectedVariantsList = filtersList.variants.data.filter(item => ids.has(item.id));
    const oldSelectedVariantsIds = new Set(oldSelectedVariantsList.map(({id}) => id));
    const newSelectedVariant = data.filter(item => !oldSelectedVariantsIds.has(item.id));
    const dataToAdd = sortArray([...oldSelectedVariantsList, ...newSelectedVariant]);
    const passedData = {...filtersList.variants, data: dataToAdd, isActive: true}
    const filterData = {...filtersList, variants: passedData}
    setFiltersList(filterData);
    getCaseCoverageData(filterData, true);
    handleAddFiltersToProcessCompareLayersTemporary("variants", filterData)
  }

  const handleExtractDataForApi = (filterData = filtersList) => {
    const filters = {
      variantsIds: [],
      caseAttributesData: [],
      dateAndTime: [],
      activeVariants: [],
      flowSelection: [],
      metrics: [],
      activitySelection: []
    }

    if (filterData.variants.isActive) {
      filters.variantsIds = filterData.variants.data.map(item => item.id);
      filters.activeVariants = filterData.variants.data.map(item => (item.is_active && item.is_active === 1) || item.is_active === undefined ? 1 : 0);
    }
    if (filterData.caseAttributes.isActive) {
      const data = filterData.caseAttributes.data.filter(item => item.column[0] !== "Column");
      filters.caseAttributesData = data.filter(item => item.value[0] !== "Value");
    }
    if (filterData.metrics.isActive) {
      const data = filterData?.metrics?.data?.filter(item => item.column !== "Column");
      filters.metrics = data?.filter(item => item?.value !== "Value");
    }
    if (filterData.dateAndTime.isActive) {
      filters.dateAndTime = filterData.dateAndTime.data;
      filters.dateAndTime = filters.dateAndTime.filter(item => item && item.value && item.value.length && item.value);
      if (process.env.REACT_APP_CALENDAR_TYPE === "persian") {
        filters.dateAndTime = filters.dateAndTime.map(item => {
          const splitDate = item.value[0]?.split(",")
          const isFa0 = JalaliMoment(splitDate[0]).year() >= 1200 && JalaliMoment(splitDate[0]).year() <=1600
          const isFa1 = JalaliMoment(splitDate[1]).year() >= 1200 && JalaliMoment(splitDate[1]).year() <=1600
          const passedDate = [isFa0
              ? JalaliMoment.from(splitDate[0], 'fa', "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss")
              : splitDate[0],
            isFa1
                ? JalaliMoment.from(splitDate[1], 'fa', "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss")
                : splitDate[1]].join(",")
          return {...item, value: [passedDate]}
        })
      }
    }
    if (filterData.flowSelection.isActive) {
      const data = filterData.flowSelection.data && filterData.flowSelection.data.length ? filterData.flowSelection.data.map(item => ({
        ...item,
        seq: item.seq && item.seq.filter(i => i.activity_name !== null)
      })) : [];
      filters.flowSelection = data && data.filter(item => item.seq && item.seq.length);
      let flowSelectionSequences = []
      flowSelectionSequences = [...filters.flowSelection?.map(item => item.seq)]
      const lastItems = flowSelectionSequences[flowSelectionSequences.length - 1];
      let d = [];
      if (lastItems && lastItems.length && lastItems[lastItems.length - 1]) {
        d = lastItems.map((item, index) => {
          if (lastItems.length - 1 === index) {
            return {...item, type: "ENDSEQUENCE"}
          } else {
            return {...item}
          }
        })
      }
      if (filters.flowSelection.length) {
        filters.flowSelection[filters.flowSelection.length - 1].seq = d
      }
    }
    if (filterData.activitySelection.isActive) {
      filters.activitySelection = filterData.activitySelection.data
    }

    const returnFiltersObject = {}
    const filtersNames = ["variantsIds", "caseAttributesData", "dateAndTime", "activeVariants", "flowSelection", "metrics", "activitySelection"]
    filtersNames.forEach(filterName => {
      if (filters[filterName]?.length) {
        returnFiltersObject[filterName] = filters[filterName]
      }
    })
    return returnFiltersObject
  }

  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }
  const prevAmount = usePrevious(filtersList);
  const prevAmountOfFlowSelection = usePrevious(filtersList.flowSelection.data);

  const comparable = o => (typeof o != 'object' || !o) ? o :
      Object.keys(o).sort().reduce((c, key) => (c[key] = comparable(o[key]), c), {});

  const handleSubmitFilters = (filterData) => {
    const filtersListData = filterData
    if (filtersListData) {
      let filterData = [];
      const data = handleExtractDataForApi(filtersListData);
      const caseAttributesData = data?.caseAttributesData?.length ? data.caseAttributesData : []
      const dateAndTimesData = data?.dateAndTime?.length ? data.dateAndTime : []
      // pass filters Object to Hessan for API Call From Backend
      const passedFilter = {
        variants: data.variantsIds,
        filters: [...caseAttributesData, ...dateAndTimesData].length ? [...caseAttributesData, ...dateAndTimesData] : undefined,
        flow: data.flowSelection,
        metrics: data.metrics,
        advanced_activity_filters: data.activitySelection
      }

      if (history.location.pathname === "/process-compare") {
        filterData = {
          ...context.handleAutoSave(),
          processCompareFilters: passedFilter.filters,
          processCompareVariants: passedFilter.variants,
          processCompareFlow: passedFilter.flow,
          processCompareMetrics: passedFilter.metrics,
          processCompareActivityFilters: passedFilter.advanced_activity_filters
        };
        context.handleAutoSave(filterData);
        context.dispatch({type: 'set_active_variants_process_compare', value: data.activeVariants});
      } else if (history.location.pathname === "/data-analysis" || location.pathname.includes("share/data_analysis")) {
        filterData = {
          ...context.handleAutoSave(),
          dataAnalysisFilters: passedFilter.filters,
          dataAnalysisVariants: passedFilter.variants,
          dataAnalysisActiveVariants: data.activeVariants,
          dataAnalysisFlow: passedFilter.flow,
          dataAnalysisMetrics: passedFilter.metrics,
          dataAnalysisAdvancedActivityFilters: passedFilter.advanced_activity_filters
        };
        context.handleAutoSave(filterData);
      } else if (history.location.pathname === "/process-explorer") {
        context.dispatch({type: 'set_process_explorer_filters', value: passedFilter.filters});
        context.dispatch({type: 'set_process_explorer_variants', value: passedFilter.variants});
        context.dispatch({type: 'set_process_explorer_active_variants', value: data.activeVariants});
        context.dispatch({type: 'set_process_explorer_flow', value: passedFilter.flow});
        context.dispatch({type: 'set_process_explorer_metrics', value: passedFilter.metrics});
        context.dispatch({type: 'set_process_explorer_advanced_activity_filters', value: passedFilter.advanced_activity_filters});
      } else if (history.location.pathname === "/conformance-checking") {
        context.dispatch({type:'set_conformance_checking_variants',value:passedFilter.variants});
        context.dispatch({type:'set_conformance_checking_active_variants',value:data.activeVariants});
        context.dispatch({type:'set_conformance_checking_flow',value:passedFilter.flow});
        context.dispatch({type:'set_conformance_checking_filters',value:passedFilter.filters});
        context.dispatch({type:'set_conformance_checking_metrics',value:passedFilter.metrics});
        context.dispatch({type:'set_conformance_checking_advanced_activity_filters',value:passedFilter.advanced_activity_filters});
      } else {
        filterData = {
          ...context.handleAutoSave(),
          processMapFilters: passedFilter.filters,
          processMapVariants: passedFilter.variants,
          processMapFlow: passedFilter.flow,
          processMapMetrics: passedFilter.metrics,
          processMapAdvancedActivityFilters: passedFilter.advanced_activity_filters
        };
        context.handleAutoSave(filterData);
        context.dispatch({type: 'set_active_variants_process_map', value: data.activeVariants});
      }
      if (history.location.pathname === "/generate-bpmn-model") {
        filterData = {
          filters: passedFilter.filters,
          variants: passedFilter.variants,
          activeVariants: data.activeVariants,
          flow: passedFilter.flow,
          metrics: passedFilter.metrics,
          activitySelection: passedFilter.advanced_activity_filters,
        };
        handleTriggerShowModal();
        context.handleSaveGenerateBpmnFilters(filterData);
      }
      context.handleFiltersSubmitClicked(true);
      if (history.location.pathname !== "/data-analysis") {
        context.selectFilter({...passedFilter, activeVariants: data.activeVariants});
      }
      context.handleChangeVariantsFilter(data.variantsIds);
      context.actionFilter("fetching");
    }
  }

  const handleSubmit = (filterData = filtersList) => {
    setIsDoneClicked(true)
    if (history.location.pathname !== "/process-compare") {
      handleSubmitFilters(filterData)
    } else {
      handleSetDataForSecondLayer(filterData)
      context.actionFilter("fetching");
    }
    context.handleIsClickedOnLayerSelection(false)
  }

  const handleSetDataForSecondLayer = () => {
    const copyData = [...context.handleLayerList()]
    const dataToPass = copyData.map(item => ({
      ...item,
      appliedFilters: item.temporaryAppliedFilters
    }))
    context.handleLayerList(dataToPass)
    //
    const currentMainLayerFilters = dataToPass.find(item => item.type === "mainLayer")?.appliedFilters
    const currentSecondLayerFilters = dataToPass.find(item => item.selected)?.appliedFilters
    // context.dispatch({type: 'set_process_compare_filters', value: {
    //     "layer1_filters": currentMainLayerFilters,
    //     "layer2_filters": passData,
    //   }})
    context.selectFilter({
      "layer1_filters": currentMainLayerFilters || {
        variants: [1],
        active_variants: [1]
      },
      "layer2_filters": currentSecondLayerFilters || {
        variants: [1],
        active_variants: [1]
      },
    })
  }

  useEffect(() => {
    if (!context.handleIsFiltersModalOpen()) {
      const copyData = [...context.handleLayerList()]
      const dataToPass = copyData.map(item => {
        item.temporaryAppliedFilters = item.appliedFilters
        return {
          ...item
        }
      })
      context.handleLayerList(dataToPass)
    }
  }, [context.handleIsFiltersModalOpen()])

  const apiCallResponse = context.actionFilter();
  useEffect(() => {
    if (isDoneClicked) {
      if (apiCallResponse === 'success') {
        if (!showActiveFiltersPopup && ((history.location.pathname === "/process-compare") || (history.location.pathname !== "/process-compare"))) {
          handleTriggerShowModal();
          setIsDoneClicked(false)
        }
        setHasError(false);
        context.actionFilter(null);
      } else if (apiCallResponse === 'error') {
        setHasError(true);
        setIsDoneClicked(false)
      }
    }
  }, [apiCallResponse, isDoneClicked]);

  const handleSubmitCaseAttributes = (data) => {
    if (filtersList.caseAttributes.data.find(item => item.addMore)) {
      data = data.filter(item => !item.addMore);
    }
    const filterData = {...filtersList, caseAttributes: {...filtersList.caseAttributes, data: data, isActive: true}}
    setFiltersList(filterData);
    if (data && data[data.length - 1]?.value[0] !== "Value") {
      getCaseCoverageData(filterData, true);
    }
    handleAddFiltersToProcessCompareLayersTemporary("caseAttributes", filterData)
  }

  const handleSubmitDateAndTime = (data) => {
    console.log('data : ',data)
    const filterData = {
      ...filtersList,
      dateAndTime: {
        ...filtersList.dateAndTime,
        originalData: data.dateToPass,
        data: data.dateToPass,
        isActive: true
      }
    }
    setFiltersList(filterData);
    let dateAndTime = data.dateToPass;
    dateAndTime = dateAndTime.filter(item => item && item.value && item.value.length && item.value);
    if (dateAndTime.length) {
      getCaseCoverageData(filterData);
    }
    handleAddFiltersToProcessCompareLayersTemporary("dateAndTime", filterData)
  }

  const handleOnChangeFlow = (data) => {
    const filterData = {
      ...filtersList,
      flowSelection: {
        ...filtersList.flowSelection,
        data: data,
        isActive: true
      }
    }
    setFiltersList(filterData);
    const sequences = data.find(item => item.seq)
    if (sequences?.seq.find(item => item.activity_name !== null)) {
      getCaseCoverageData(filterData);
    }
    handleAddFiltersToProcessCompareLayersTemporary("flowSelection", filterData)
  }

  const handleChangeActivitySelection = data => {
    const filterData = {...filtersList}
    // filterData.activitySelection.data?.length ?
    //   filterData.activitySelection.data[filterData.activitySelection.data?.length - 1] = data :
    //   filterData.activitySelection.data = [data]
    // setFiltersList(filterData);

    filterData.activitySelection.data?.length ?
        filterData.activitySelection.data[filterData.activitySelection.data?.length - 1] = data :
        filterData.activitySelection.data = [data]

    filterData.activitySelection.isActive = true
    setFiltersList(filterData);
    handleAddFiltersToProcessCompareLayersTemporary("activitySelection", filterData)
    if (data.value?.length && data.operand?.length && data.operand?.[0]) {
      getCaseCoverageData(filterData);
    }
  }

  const handleOnChangeMetrics = (data) => {
    if (filtersList.metrics?.data?.find(item => item.addMore)) {
      data = data.filter(item => !item.addMore);
    }
    const filterData = {
      ...filtersList,
      metrics: {
        ...filtersList.metrics,
        data: data,
        isActive: true
      }
    }
    setFiltersList(filterData);
    getCaseCoverageData(filterData, true);
    handleAddFiltersToProcessCompareLayersTemporary("metrics", filterData)
  }

  const handleActiveFilter = (filterType) => {
    let filterData = {...filtersList};
    const copyOfFiltersList = {...filtersList};
    if (disabledFilters.some(item => item === filterType)) {
      const filtered = disabledFilters.filter(item => item !== filterType)
      setDisabledFilters(filtered)
    } else {
      setDisabledFilters([...disabledFilters, filterType])
    }
    if (filterType === "variants") {
      const variantsData = copyOfFiltersList?.variants?.data
      const disabledVariantsData = variantsData?.map(item => ({...item, is_active: item.is_active === 1 ? 0 : 1}))
      filterData = {...filtersList, variants: {...filtersList.variants, data: disabledVariantsData}}
    } else {
      filterTypes.forEach(type => {
        const data = copyOfFiltersList[filterType]?.data
        const disabledData = data?.map(item => ({...item, is_active: item.is_active === true ? false : true}))
        if (filterType === "dateAndTime") {
          filterData[filterType] = {...filtersList[filterType], data: disabledData, originalData: disabledData}
        } else {
          filterData[filterType] = {...filtersList[filterType], data: disabledData}
        }
      })
    }
    setFiltersList(filterData)
    getCaseCoverageData(filterData)
    if (showActiveFiltersPopup) {
      handleSubmit(filterData)
    }
  }

  const handleAddFilter = (param, filterType) => {
    switch (filterType) {
      case 'variants':
        setFiltersList({
          ...filtersList,
          variants: {...filtersList.variants, isSelected: true},
          flowSelection: {...filtersList.flowSelection, isSelected: false},
          caseAttributes: {...filtersList.caseAttributes, isSelected: false},
          dateAndTime: {...filtersList.dateAndTime, isSelected: false},
          metrics: {...filtersList.metrics, isSelected: false},
          activitySelection: {...filtersList.activitySelection, isSelected: false},
        });
        break;
      case 'flowSelection':
        let flowSelectionFilterList = {
          ...filtersList,
          variants: {...filtersList.variants, isSelected: false},
          flowSelection: {...filtersList.flowSelection, isSelected: true},
          caseAttributes: {...filtersList.caseAttributes, isSelected: false},
          dateAndTime: {...filtersList.dateAndTime, isSelected: false},
          metrics: {...filtersList.metrics, isSelected: false},
          activitySelection: {...filtersList.activitySelection, isSelected: false},
        };
        if (param === "addMore") {
          const activityItems = filtersList.flowSelection.data;
          if (activityItems[activityItems.length - 1].seq[activityItems[activityItems.length - 1].seq.length - 1].activity_name) {
            flowSelectionFilterList = {
              ...filtersList,
              flowSelection: {
                ...filtersList.flowSelection, data: [...activityItems, {
                  is_active: true,
                  seq: [
                    {
                      activity_name: null,
                      type: "ENDSEQUENCE"
                    }
                  ]
                }]
              }
            }
          }
        }

        setFiltersList(flowSelectionFilterList);
        break;
      case 'caseAttributes':
        let newFiltersList = {
          ...filtersList,
          variants: {...filtersList.variants, isSelected: false},
          flowSelection: {...filtersList.flowSelection, isSelected: false},
          caseAttributes: {...filtersList.caseAttributes, isSelected: true},
          dateAndTime: {...filtersList.dateAndTime, isSelected: false},
          metrics: {...filtersList.metrics, isSelected: false},
          activitySelection: {...filtersList.activitySelection, isSelected: false},
        }

        if (param === "addMore") {
          let data = [...filtersList.caseAttributes.data];
          if (!filtersList.caseAttributes.data.find(item => item.value[0] === "Value")) {
            data = [
              ...data,
              {column: ["Column"], operand: ["Operand"], value: ["Value"], addMore: true}
            ];
          }
          newFiltersList = {
            ...filtersList,
            caseAttributes: {
              ...filtersList.caseAttributes,
              data,
              isActive: true
            }
          };
        }

        setFiltersList(newFiltersList);
        break;
      case 'dateAndTime':
        let dateAndTimeFiltersList = {
          ...filtersList,
          variants: {...filtersList.variants, isSelected: false},
          flowSelection: {...filtersList.flowSelection, isSelected: false},
          caseAttributes: {...filtersList.caseAttributes, isSelected: false},
          dateAndTime: {...filtersList.dateAndTime, isSelected: true},
          metrics: {...filtersList.metrics, isSelected: false},
          activitySelection: {...filtersList.activitySelection, isSelected: false},
        }
        if (param === "addMore") {
          if (filtersList.dateAndTime.data[filtersList.dateAndTime.data.length - 1].value) {
            let data = [
              ...filtersList.dateAndTime.data,
              {column: filtersList.dateAndTime.data[0].column, operand: ["Operand"], value: [], addMore: true}
            ];
            if (filtersList.dateAndTime.data.find(item => item.addMore)) {
              data = [
                ...data.filter(item => !item.addMore),
                {column: filtersList.dateAndTime.data[0].column, operand: ["Operand"], value: [], addMore: true}
              ];
            }
            dateAndTimeFiltersList = {
              ...filtersList,
              dateAndTime: {
                ...filtersList.dateAndTime,
                data,
                isActive: true
              }
            };
          }
        }
        setFiltersList(dateAndTimeFiltersList);
        break;
      case 'metrics':
        let metricsFiltersList = {
          ...filtersList,
          variants: {...filtersList.variants, isSelected: false},
          flowSelection: {...filtersList.flowSelection, isSelected: false},
          caseAttributes: {...filtersList.caseAttributes, isSelected: false},
          dateAndTime: {...filtersList.dateAndTime, isSelected: false},
          metrics: {...filtersList.metrics, isSelected: true},
          activitySelection: {...filtersList.activitySelection, isSelected: false},
        }
        if (param === "addMore") {
          if (filtersList.metrics.data[filtersList.metrics.data.length - 1]?.value !== "Value") {
            let data = [
              ...filtersList.metrics.data,
              {column: "Column", operand: "Operand", value: "Value", addMore: true}
            ];
            if (filtersList.metrics.data.find(item => item.addMore)) {
              data = [
                ...data.filter(item => !item.addMore),
                {column: "Column", operand: "Operand", value: "Value", addMore: true}
              ];
            }
            metricsFiltersList = {
              ...filtersList,
              metrics: {
                ...filtersList.metrics,
                data,
                isActive: true
              }
            };
          }
        }
        setFiltersList(metricsFiltersList);
        break;
      case 'activitySelection':
        let activityFiltersList = {
          ...filtersList,
          variants: {...filtersList.variants, isSelected: false},
          flowSelection: {...filtersList.flowSelection, isSelected: false},
          caseAttributes: {...filtersList.caseAttributes, isSelected: false},
          dateAndTime: {...filtersList.dateAndTime, isSelected: false},
          metrics: {...filtersList.metrics, isSelected: false},
          activitySelection: {...filtersList.activitySelection, isSelected: true},
        }

        if (param === "addMore") {
          activityFiltersList.activitySelection.data.push({
            is_active: true,
            logic: undefined,
            operand: undefined,
            value: []
          })
        }

        setFiltersList(activityFiltersList);
        break;
      default:
        break;
    }
  }

  const token = localStorage.getItem('token');
  const handleRemoveFilterItem = (id, index, type) => {
    let data = null;
    let filteredData = [];
    switch (type) {
      case 'variants':
        data = filtersList.variants.data.filter(item => item.id !== id);
        filteredData = {
          ...filtersList,
          variants: {...filtersList.variants, data: data, isActive: true, isSelected: !!data.length}
        }
        setFiltersList(filteredData)
        getCaseCoverageData(filteredData)
        break;
      case 'caseAttributes':
        data = filtersList.caseAttributes.data.filter((item, i) => i !== index);
        filteredData = {
          ...filtersList,
          caseAttributes: {
            ...filtersList.caseAttributes,
            data: data,
            isActive: true,
            isSelected: !!data.length
          }
        }
        setFiltersList(filteredData)
        getCaseCoverageData(filteredData)
        break;
      case 'dateAndTime':
        data = filtersList.dateAndTime.data.filter((item, i) => i !== index);
        const removedFromOriginalData = filtersList.dateAndTime.originalData.slice(index);
        const dataAfterDeletedItems = filtersList.dateAndTime.originalData.filter(item => !removedFromOriginalData.includes(item));
        filteredData = {
          ...filtersList,
          dateAndTime: {
            ...filtersList.dateAndTime,
            originalData: dataAfterDeletedItems,
            data: data,
            isActive: true,
            isSelected: !!data.length
          }
        }
        setFiltersList(filteredData)
        getCaseCoverageData(filteredData)
        break;
      case 'flowSelection':
        const newData = {...filtersList.flowSelection} // copy
        const items = newData.data.splice(index, 1);
        setTimeout(() => {
          filteredData = {...filtersList, flowSelection: {...newData, isSelected: !!newData.data.length}}
          setFiltersList(filteredData)
          getCaseCoverageData(filteredData)
        }, 0)
        break;
      case 'metrics':
        let copyOfMetricsData = {...filtersList.metrics}
        copyOfMetricsData.data.splice(index, 1)
        setTimeout(() => {
          filteredData = {...filtersList, metrics: {...copyOfMetricsData, isSelected: !!copyOfMetricsData.data.length}}
          setFiltersList(filteredData)
          getCaseCoverageData(filteredData)
        }, 0)
        break;
      case 'activitySelection':
        let copyOfActivitySelectionData = {...filtersList.activitySelection}
        copyOfActivitySelectionData.data.splice(index, 1)
        setTimeout(() => {
          filteredData = {...filtersList, activitySelection: {...copyOfActivitySelectionData, isSelected: !!copyOfActivitySelectionData.data.length}}
          setFiltersList(filteredData)
          getCaseCoverageData(filteredData)
        }, 0)
        break;
      default:
        break;
    }
  }

  let analysisId = null;
  if (context.handleUid().id) {
    analysisId = context.handleUid().id;
  } else {
    analysisId = JSON.parse(localStorage.getItem("mapData"))?.id;
  }

  const callApiCaseCoverage = (data, forceCall) => {
    if(!analysisId) return;
    if (canCallCaseCoverageApi || forceCall) {
      apiCaseCoverage.postSingle(analysisId, data, token).then(res => {
        setCaseCoverageData(res.response.data.data);
        setCaseCoverageStatus("success")
        setCanCallCaseCoverageApi(true)
        context.handleCaseCoverageData(res.response.data.data)
      })
        .catch(err => {
          console.log(err);
          setCanCallCaseCoverageApi(true)
          setCaseCoverageStatus("error")
          setCaseCoverageData(null);
        })
    }
  }

  const getCaseCoverageData = (filterData, forceCall = false) => {
    if (location.pathname !== "/map") {
      if (location.pathname === "/process-compare" && !context.handleIsFiltersModalOpen()) return
      setCaseCoverageStatus("fetching")
      const data = handleExtractDataForApi(filterData);
      const caseAttributesData = data?.caseAttributesData?.length ? data.caseAttributesData : []
      const dateAndTime = data?.dateAndTime?.length ? data.dateAndTime : []
      if (!data.caseAttributesData?.length ||
          (data.caseAttributesData.length &&
              data.caseAttributesData[data.caseAttributesData.length - 1].value &&
              data.caseAttributesData[data.caseAttributesData.length - 1].value[0] !== "Value")
      ) {
        const passedFilter = {
          variants: data.variantsIds,
          filters: [...caseAttributesData, ...dateAndTime].length ? [...caseAttributesData, ...dateAndTime] : undefined,
          active_variants: data.activeVariants,
          flow: data.flowSelection,
          metrics: data.metrics,
          advanced_activity_filters: data.activitySelection
        }

        callApiCaseCoverage(passedFilter, forceCall)
        setCanCallCaseCoverageApi(false)
      }
    }
  }

  const sortArray = (array) => {
    return array.sort((a, b) => {
      if (a.id > b.id) {
        return 1
      }
      return -1
    });
  }

  const handleTriggerDisableFilterItem = (id, index, type) => {
    const newData = {...filtersList}; // copy
    switch (type) {
      case 'variants':
        const isActiveVariants = newData.variants.data[index].is_active;
        (isActiveVariants && isActiveVariants === 1) || isActiveVariants === undefined ? newData.variants.data[index].is_active = 0 : newData.variants.data[index].is_active = 1;
        setFiltersList(newData);
        getCaseCoverageData(newData);
        break;
      case 'caseAttributes':
        const isActiveCaseAttributes = newData.caseAttributes.data[index].is_active;
        (isActiveCaseAttributes && isActiveCaseAttributes === true) || isActiveCaseAttributes === undefined ? newData.caseAttributes.data[index].is_active = false : newData.caseAttributes.data[index].is_active = true;
        setFiltersList(newData);
        getCaseCoverageData(newData);
        break;
      case 'dateAndTime':
        const isActiveDateAndTime = newData.dateAndTime.data[index].is_active;
        (isActiveDateAndTime && isActiveDateAndTime === true) || isActiveDateAndTime === undefined ? newData.dateAndTime.data[index].is_active = false : newData.dateAndTime.data[index].is_active = true;
        setFiltersList(newData);
        getCaseCoverageData(newData);
        break;
      case 'flowSelection':
        newData.flowSelection.data[index].is_active === true ? newData.flowSelection.data[index].is_active = false : newData.flowSelection.data[index].is_active = true;
        setFiltersList(newData);
        getCaseCoverageData(newData);
        break;
      case 'metrics':
        newData.metrics.data[index].is_active === true ? newData.metrics.data[index].is_active = false : newData.metrics.data[index].is_active = true;
        setFiltersList(newData);
        getCaseCoverageData(newData);
        break;
      case 'activitySelection':
        newData.activitySelection.data[index].is_active === true ? newData.activitySelection.data[index].is_active = false : newData.activitySelection.data[index].is_active = true;
        setFiltersList(newData);
        getCaseCoverageData(newData);
        break;
      default:
        break;
    }
    if (showActiveFiltersPopup) {
      handleSubmit();
    }
  }

  const filterTypes = ["flowSelection", "caseAttributes", "dateAndTime", "metrics"]

  useEffect(() => {
    if (JSON.stringify(prevAmount) !== JSON.stringify(filtersList) || JSON.stringify(prevAmountOfFlowSelection !== JSON.stringify(filtersList.flowSelection.data))) {
      const data = handleExtractDataForApi();
      if (data?.caseAttributesData?.length === 0 && data.dateAndTime.length === 0 && data.variantsIds.length === 0) {
        if (history.location.pathname === '/data-analysis' || history.location.pathname === '/conformance-checking' || history.location.pathname === '/process-explorer') {
          setDisableSubmitButton(false);
          return;
        }
        setDisableSubmitButton(true);
      } else {
        setDisableSubmitButton(false);
      }
    }

    let disabledFiltersList = [...disabledFilters];
    if (filtersList.variants.data && filtersList.variants.data.length !== 0 && filtersList.variants.data.findIndex(item => item.is_active === 1) === -1) {
      disabledFiltersList.push("variants")
    } else {
      disabledFiltersList = disabledFiltersList.filter(item => item !== "variants")
    }
    filterTypes.forEach(filterType => {
      if (filtersList[filterType].data && filtersList[filterType].data.length !== 0 && filtersList[filterType].data?.findIndex(item => item?.is_active === true) === -1) {
        disabledFiltersList.push(filterType)
      } else {
        disabledFiltersList = disabledFiltersList.filter(item => item !== filterType)
      }
    })
    setDisabledFilters(disabledFiltersList)
  }, [filtersList]);

  const convertSecondsToTimeParameters = (value) => {
    const aYear = 31536000
    const aDay = 86400
    const anHour = 3600
    const aMinute = 60

    const year = Math.floor(value / aYear) || 0
    const day = Math.floor((value - year * aYear) / aDay) || 0;
    const hour = Math.floor((value - year * aYear - day * aDay) / anHour) || 0;
    const minute = Math.floor((value - year * aYear - day * aDay - hour * anHour) / aMinute) || 0;

    return {
      year,
      day,
      hour,
      minute
    }
  }

  const filterItemTemplate = (value, item, index, activeFilters = false) => {
    return item && <FilterItem
        isActive={disabledFilters?.length ? disabledFilters.findIndex(item => item === value.type) === -1 : true}
        isActiveItem={item.is_active}
        id={item.id}
        handleRemoveItem={(id) => handleRemoveFilterItem(id, index, value.type)}
        handleTriggerDisableFilterItem={(id) => handleTriggerDisableFilterItem(id, index, value.type)}
        onClick={(id) => handleTriggerDisableFilterItem(id, index, value.type)}
        readOnly={activeFilters}
        halfWidth={value.type === 'variants'}
        themeColor={themeColor}
    >
      {
        value.type === 'variants' &&
        (
            <div className={'d-flex justify-content-between'}>
              <span>Variant {item.id}</span>
              {
                !activeFilters && <span>{item.percentage}% | {item.count}</span>
              }
            </div>
        )
      }
      {
        value.type === 'caseAttributes' &&
        (
            <div>
              <div className={`${styles.title} ${activeFilters && 'text-left'}`}>{item.column[0]}</div>
              {
                item.value ? item.value.map((i, index) => <div key={`${index}_${i}`} className={activeFilters && 'text-left'}>{i}</div>) : null
              }
            </div>
        )
      }
      {
        value.type === 'dateAndTime' &&
        (
            <div>
              <div className={`${styles.title} ${activeFilters && 'text-left'}`}>{item.column}</div>
              {
                item.value ? item.value.map(i => i.split(",").map(x => {
                  const isFa = JalaliMoment(x).year() >= 1200 && JalaliMoment(x).year() <=1600
                  return (process.env.REACT_APP_CALENDAR_TYPE === "persian"
                      ? isFa ? JalaliMoment(x, "jYYYY-jMM-jDD").format("jYYYY-jMM-jDD") : JalaliMoment(x).locale("fa").format("jYYYY-jMM-jDD")
                      : moment(x).format("DD MMM YYYY"))
                }).join(" - ")) : null
              }
            </div>
        )
      }
      {
        value.type === 'flowSelection' &&
        <div>
          <div className={`${styles.title} ${activeFilters && 'text-left'}`}>Sequence</div>
          {
            item.seq && item.seq.length &&
            (
                item.seq.filter(i => i.activity_name !== null).length > 4 ?
                    [...item.seq.slice(0, 3), {activity_name: "..."}, item.seq.filter(i => i.activity_name !== null)[item.seq.filter(i => i.activity_name !== null).length - 1]].map((item, index) =>
                        <div key={`${index}_${item.activity_name}`} className={`${activeFilters ? 'text-left mb-0' : 'mb-2'}`}>{item.activity_name}</div>) :
                    item.seq.map((item,index) => <div key={`${index}_${item.activity_name}_0`} className={`${activeFilters ? 'text-left mb-0' : 'mb-2'}`}>{item.activity_name}</div>)
            )
          }
        </div>
      }
      {
        value.type === 'metrics' &&
        (
            <div>
              <div className={`${styles.title} ${activeFilters && 'text-left'}`}>{item.column}</div>
              {
                <div className={`${styles.title} ${activeFilters && 'text-left'}`}>
                  <span>{ item.operand }</span>
                  {
                    item.column !== "tpt" ?
                        (
                            <span> { Array.isArray(item.value) ? <span>{ item.value[0] } - { item.value[1] }</span> : <span>{ item.value }</span> } </span>
                        ) : (
                            Array.isArray(item.value) ?
                                <span>
                          <span>
                            <span> {convertSecondsToTimeParameters(item.value[0]).year} Y </span>
                            <span> {convertSecondsToTimeParameters(item.value[0]).day} D </span>
                            <span> {convertSecondsToTimeParameters(item.value[0]).hour} H </span>
                            <span> {convertSecondsToTimeParameters(item.value[0]).minute} M </span>
                          </span> -
                          <span>
                            <span> {convertSecondsToTimeParameters(item.value[1]).year} Y </span>
                            <span> {convertSecondsToTimeParameters(item.value[1]).day} D </span>
                            <span> {convertSecondsToTimeParameters(item.value[1]).hour} H </span>
                            <span> {convertSecondsToTimeParameters(item.value[1]).minute} M </span>
                          </span>
                        </span>:
                                <span>
                          <span> {convertSecondsToTimeParameters(item.value).year} Y </span>
                          <span> {convertSecondsToTimeParameters(item.value).day} D </span>
                          <span> {convertSecondsToTimeParameters(item.value).hour} H </span>
                          <span> {convertSecondsToTimeParameters(item.value).minute} M </span>
                        </span>
                        )
                  }
                </div>
              }
            </div>
        )
      }
      {
        value.type === "activitySelection" &&
        <>
          {
            item.logic &&
            <div className={['mt-1 mb-1', activeFilters && 'text-left', styles.activitySelectionLogicTag].join(' ')}>{item.logic}</div>
          }
          {
            item.operand?.length ?
                <div className={[styles.title, activeFilters && 'text-left'].join(' ')}>{item.operand[0]}</div> : <div>Select Rule</div>
          }
          {
            item.value?.map(activity => <div className={["mb-1", activeFilters && 'text-left'].join(" ")}>{activity}</div>)
          }
        </>

        // <>
        //   {
        //     item.map(activityItem => <>
        //       {
        //         activityItem.logic &&
        //           <div className={['mt-1 mb-1', styles.activitySelectionLogicTag].join(' ')}>{activityItem.logic}</div>
        //       }
        //       {
        //         activityItem.rule ?
        //           <div className={styles.title}>{activityItem.rule}</div> : <div>Select Rule</div>
        //       }
        //
        //       {
        //         activityItem.activities.map(activity => <div className={"mb-1"}>{activity}</div>)
        //       }
        //     </>)
        //   }
        // </>
      }
    </FilterItem>
  };

  const handleToggleShowMore = () => {
    setShowMore(!showMore);
  }

  const handleShowFilterWrapperTemplate = (key, value, activeFilters = false) => {
    let items = value.data && value.data.length !== 0 ? value.data : null
    if (items) {
      items = items.slice(0, 4);
      const moreItems = value.data.slice(4, value.data.length + 1);
      return <div className={activeFilters && `d-flex ${styles.activeFilters}`}>
        {
          items.map((item, index) => {
            return filterItemTemplate(value, item, index, activeFilters);
          })
        }
        {
          showMore && moreItems.map((item, index) => (
              filterItemTemplate(value, item, index + 4, activeFilters)
          ))
        }
        {
          (moreItems.length > 0 && !activeFilters) &&
          <div onClick={handleToggleShowMore} className={`${styles.showMoreBtn} d-flex justify-content-between`}>
            <div className={'d-flex align-items-center'}>Multiple Items...</div>
            <div className={showMore && styles.showLess}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.18282 13.1666V3.16663" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round"
                      strokeLinejoin="round"/>
                <path d="M12.1991 9.13342L8.18311 13.1668L4.16644 9.13342" stroke="#0A195C" strokeWidth="1.5"
                      strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        }
        {
          (moreItems.length > 0 && activeFilters) &&
          <FilterItem onClick={handleToggleShowMore} readOnly isActiveItem={!showMore}>
            More Items...
          </FilterItem>
        }
      </div>
    }
  }

  const Wrapper = (props) => {
    const [expanded, setExpanded] = useState(false);

    const handleToggleCollapse = () => {
      setExpanded(!expanded);
    }

    const handleRemove = () => {
      const copyFiltersList = {...filtersList};
      if (copyFiltersList[props.item].type === "dateAndTime") {
        copyFiltersList[props.item].originalData = [];
      }
      copyFiltersList[props.item].data = [];
      setFiltersList(copyFiltersList);
      getCaseCoverageData(copyFiltersList);
      handleSubmit();
    }

    const handleSetActiveFilter = () => {
      handleActiveFilter(props.item)
    }

    return (
        <div className={`${styles.wrapper} ${expanded && styles.expanded} `}>
          <div className={`${styles.header} d-flex justify-content-between align-items-center`}>
            <div className={`${styles.title} d-flex`}>
              {props.item}
            </div>
            <div className={`${styles.operations} d-flex`}>
              <div className={'d-flex'}>
                <SwitchKey
                    handleOnChange={handleSetActiveFilter}
                    active={disabledFilters?.length ? disabledFilters.findIndex(item => item === props.item) === -1 : true}
                />
              </div>
              <div onClick={handleRemove} className={'d-flex cursor-pointer'}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M3.11673 6.31213C3.11673 6.31213 3.47873 10.8021 3.68873 12.6935C3.78873 13.5968 4.34673 14.1261 5.26073 14.1428C7.00006 14.1741 8.74139 14.1761 10.4801 14.1395C11.3594 14.1215 11.9081 13.5855 12.0061 12.6981C12.2174 10.7901 12.5774 6.31213 12.5774 6.31213"
                      stroke="#FF0053" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2.19455 4.15975L13.4999 4.15975" stroke="#FF0053" strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"/>
                  <path
                      d="M4.37299 4.15974C4.89632 4.15974 5.34699 3.78974 5.44965 3.27707L5.61165 2.46641C5.71165 2.09241 6.05032 1.83374 6.43632 1.83374L9.25832 1.83374C9.64432 1.83374 9.98299 2.09241 10.083 2.46641L10.245 3.27707C10.3477 3.78974 10.7983 4.15974 11.3217 4.15974"
                      stroke="#FF0053" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={`${styles.collapseIcon} d-flex cursor-pointer`} onClick={handleToggleCollapse}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.6667 10.3334L8.00004 5.66671L3.33337 10.3334" stroke="#0A195C" strokeWidth="1.5"
                        strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
          <div className={styles.content}>
            { handleShowFilterWrapperTemplate(props.item, props.value, true) }
          </div>
        </div>
    )
  }

  const renderFiltersPopupTemplate = () => {
    return (
        Object.entries(filtersList).map(([key, value], index) => (
            value?.data?.length ? <Wrapper item={key} value={value} index={index} /> : null
        ))
    )
  }

  const node = useRef(null);
  useEffect(() => {
    if (showActiveFiltersPopup) {
      // document.addEventListener("click", handleOutsideClick, false);
      return function cleanupListener() {
        // document.removeEventListener('click', handleOutsideClick, false)
        // handleTriggerShowModal();
      }
    }
  }, [showActiveFiltersPopup]);

  const location = useLocation()
  useEffect(() => {
    setCaseCoverageData({
      case_coverage_percentage: "0%",
      covered_cases: 0,
      covered_events: 0,
      covered_variants: 0,
      event_coverage_percentage: "0%",
      total_cases: 0,
      total_events: 0,
      total_variants: 0,
      variants_coverage_percentage: "0%",
    })
    return () => {
      handleTriggerShowModal()
      context.handleSaveGenerateBpmnFilters({})
      context.handleIsVariantExplorerLinked(false)
    }
  }, [location.pathname])

  const themeColor = context?.handleLayerList()?.length ? context?.handleLayerList()?.find(item => item.selected)?.color : null

  return (
      <React.Fragment>
        <div className={[styles.Filters, (showModal ? styles.show : styles.hide)].join(' ')}>
          <div className={[styles.modalBox, (mode === 'sideBySide' ? styles.sideBySide : '')].join(' ')}>
            {
              hasError ? (
                  <div className={`d-flex justify-content-between ${styles.header} ${styles.error}`}>
                    <div className={'d-flex align-items-center'}>
                      Selected Filters has no results, Please check the filter panel and try again with different filter
                      set.
                    </div>
                    <div onClick={() => setHasError(false)}>
                      <i>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line x1="15.834" y1="5.22732" x2="5.22798" y2="15.8333" stroke="white" strokeWidth="1.5"
                                strokeLinecap="round"/>
                          <path d="M4.94434 4.94442L15.786 15.7861" stroke="white" strokeWidth="1.5"
                                strokeLinecap="round"/>
                        </svg>
                      </i>
                    </div>
                  </div>
              ) : (
                  <div className={styles.header}>
                <span className={styles.title}>
                  <span>Filters</span>
                </span>
                    <span className={styles.close} onClick={handleTriggerShowModal}>
                  <i>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <line x1="19" y1="6.06066" x2="6.06066" y2="19" stroke="#70789E" strokeWidth="1.5"
                            strokeLinecap="round"/>
                      <path d="M5.93335 5.93331L18.9434 18.9434" stroke="#70789E" strokeWidth="1.5"
                            strokeLinecap="round"/>
                    </svg>
                  </i>
                </span>
                  </div>
              )
            }
            <div className={[styles.body, 'container-fluid'].join(' ')}>
              <div className={[styles.fullHeight, 'row'].join(' ')}>
                <div className={[styles.filtersSelectionContainer, styles.fullHeight, 'pb-5'].join(' ')}>
                  <Scrollbars
                      style={{paddingLeft: 26, paddingTop: 20}}
                      renderView={({style, ...props}) =>
                          <div {...props}
                               style={{...style, width: "100%", height: "100%", overflowX: 'hidden', paddingLeft: 45}}/>}
                      renderTrackVertical={({style, ...props}) =>
                          <div {...props}
                               style={{...style, backgroundColor: '#E8EBFF', width: 1, borderRadius: 4, height: "100%"}}/>
                      }
                      renderThumbVertical={({style, ...props}) =>
                          <div {...props} style={{
                            ...style,
                            backgroundColor: '#C2C7ED',
                            width: 4,
                            borderRadius: 4,
                            cursor: "pointer",
                            left: -1
                          }}/>
                      }
                  >
                    {
                      Object.entries(filtersList).map(([key, value]) => (
                          <div key={value.id} className={styles.filtersWrapper}>
                            <FilterWrapper
                                title={value.title}
                                isActive={disabledFilters?.length ? disabledFilters.findIndex(item => item === key) === -1 : true}
                                isSelected={value.isSelected}
                                handleActiveFilter={() => handleActiveFilter(value.type)}
                                handleAddFilter={(param) => handleAddFilter(param, value.type)}
                                disabled={value.isDisabled}
                                themeColor={themeColor}
                            >
                              {handleShowFilterWrapperTemplate(key, value)}
                            </FilterWrapper>
                          </div>
                      ))
                    }
                  </Scrollbars>
                </div>
                {
                  filtersList.variants && filtersList.variants.isSelected && (
                      <VariantsFilterPicker
                          title={'Variants'}
                          selectedItems={filtersList.variants.data.map(item => item.id)}
                          handleSetVariantsFiltersList={(data) => handleSetVariantsFiltersList(data)}
                          handleSubmit={() => handleSubmit()}
                          themeColor={themeColor}
                      />
                  )
                }
                {
                  filtersList.caseAttributes && filtersList.caseAttributes.isSelected && (
                      <CaseAttributesFilterPicker
                          title={'Case Attributes'}
                          selectedItems={filtersList.caseAttributes.data}
                          handleSubmitFilters={handleSubmitCaseAttributes}
                          handleAddNewFilter={handleAddFilter}
                          themeColor={themeColor}
                      />
                  )
                }
                {
                  filtersList.dateAndTime && filtersList.dateAndTime.isSelected && (
                      <DateAndTimeFilterPicker
                          title={'Date and Time'}
                          selectedItems={filtersList.dateAndTime}
                          handleSubmitFilters={handleSubmitDateAndTime}
                          handleSubmit={() => handleSubmit()}
                      />
                  )
                }
                {
                  filtersList.flowSelection && filtersList.flowSelection.isSelected && (
                      <FlowSelection
                          title={'Flow Selection'}
                          selectedItems={filtersList.flowSelection}
                          handleAddNewFilter={handleAddFilter}
                          handleOnChangeFlow={handleOnChangeFlow}
                          handleSubmit={() => handleSubmit()}
                          themeColor={themeColor}
                      />
                  )
                }
                {
                  filtersList.metrics && filtersList.metrics.isSelected && (
                      <Metrics
                          title={'Metrics'}
                          selectedItems={filtersList.metrics}
                          onChangeMetrics={handleOnChangeMetrics}
                          handleAddNewFilter={handleAddFilter}
                          themeColor={themeColor}
                      />
                  )
                }
                {
                  filtersList.activitySelection && filtersList.activitySelection.isSelected && (
                      <ActivitySelection
                          title={'Activity Selection'}
                          selectedItems={filtersList.activitySelection?.data?.length && filtersList.activitySelection?.data[filtersList.activitySelection?.data?.length - 1]}
                          onChangeFilter={handleChangeActivitySelection}
                          themeColor={themeColor}
                      />
                  )
                }
                <div className={[styles.buttons, 'd-flex'].join(' ')}>
                  <Button
                      disabled={!context.handleIsClickedOnLayerSelection() && disableSubmitButton}
                      height={"medium"}
                      onClick={() => handleSubmit()}
                      title={(apiCallResponse === "fetching") && !context.handleIsClickedOnLayerSelection() && history.location.pathname !== "/generate-bpmn-model" ? 'Processing...' : 'Done'}
                      type={(apiCallResponse === "fetching") && !context.handleIsClickedOnLayerSelection() &&  history.location.pathname !== "/generate-bpmn-model" ? 'disabled' : 'primary'}
                      color={themeColor}
                      size={'block'}
                  />
                </div>
              </div>
            </div>
          </div>
          {
            history.location.pathname === "/process-compare" &&
            <LayerSelection />
          }
          <div className={styles.caseCoverageWrapper}>
            <CaseCoverage
                caseCoverageData={caseCoverageData}
                caseCoverageStatus={caseCoverageStatus}
            />
          </div>
        </div>
        {
          showActiveFiltersPopup &&
          <div className={`${styles.ActiveFiltersPopup}`} ref={node}>
            <div className={`${styles.header}`}>
              <div>
                <div className={`${styles.title} d-flex justify-content-between align-items-center`}>
                  <div>
                    Active Filters
                  </div>
                  <div className={'d-flex cursor-pointer'} onClick={handleTriggerShowModal}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <line x1="0.75" y1="-0.75" x2="12.4493" y2="-0.75"
                            transform="matrix(0.707107 0.707107 0.707107 -0.707107 3.33325 3.33337)" stroke="#060F36"
                            strokeWidth="1.5" strokeLinecap="round"/>
                      <path d="M12.0444 3.95556L3.37106 12.6289" stroke="#060F36" strokeWidth="1.5"
                            strokeLinecap="round"/>
                    </svg>
                  </div>
                </div>
                <div className={styles.subtitle}>
                  {
                    history.location.pathname !== "/process-compare" ?
                        Object.entries(filtersList).filter(item => item[1]?.data?.length > 0).length
                        : Object.entries(context?.handleLayerList()?.find(item => item.type === "mainLayer")?.appliedFilters).length - 1
                  }
                  &nbsp;Filters
                </div>
              </div>
            </div>
            <div className={styles.mainContent}>
              {
                renderFiltersPopupTemplate()
              }
            </div>
            <div className={`${styles.caseCoverageStatisticsSection} d-flex align-items-center justify-content-center`}>
              <CaseCoverage
                  caseCoverageData={caseCoverageData}
                  activeFilters
              />
            </div>
          </div>
        }

      </React.Fragment>
  )
}

export default Filters;
